<template>
  <div class="field-checkbox">
    <div class="checkbox component">
      <input
        :id="name"
        type="checkbox"
        :value="value"
        :name="name"
        :checked="isSelected"
        :disabled="disabled"
        @change="toggleCheck($event)"
        @focus="focused = true"
        @blur="focused = false"
        @click="onClick"
      />
    </div>
  </div>
  <span :class="['input-label']"> {{ value }} -- {{ isSelected }}</span>
</template>

<script>
export default {
  props: {
    model: {
      type: [String, Boolean, Object, Number, Array],
      required: true,
    },
    value: {
      type: [String, Boolean, Object, Number],
      required: true,
    },
    falseValue: {
      default: false,
    },
    label: String,
    disabled: Boolean,
    checked: Boolean,
  },
  emits: ["change"],
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    isModelArray() {
      return Array.isArray(this.model);
    },
    isValueObject() {
      return this.value !== null && typeof this.value === "object";
    },
    isSelected() {
      const { model, value, isEqual, isValueObject, isModelArray } = this;

      if (isModelArray) {
        if (isValueObject) {
          return model.some((obj) => isEqual(obj, value));
        } else {
          return model.includes(value);
        }
      }

      if (isValueObject) {
        return isEqual(model, value);
      }

      return model === value;
    },
    stateClasses() {
      return {
        checked: this.isSelected,
        focused: this.focused,
        disabled: this.disabled,
      };
    },
  },

  created() {
    // this.onClick();
  },
  methods: {
    toggleCheck(event) {
      if (!this.disabled) {
        if (this.isModelArray) {
          this.handleArrayCheckbox();
        } else {
          this.handleSingleSelectCheckbox();
        }
      }
    },
    handleArrayCheckbox() {
      const newModel = this.model;

      if (!this.isSelected) {
        this.addValueToModel(newModel);
      } else {
        this.removeValueFromModel(newModel);
      }
    },
    handleSingleSelectCheckbox() {
      this.$emit("change", this.isSelected ? this.falseValue : this.value);
    },
    removeValueFromModel(newModel) {
      if (this.isValueObject) {
        newModel = newModel.filter((obj) => !this.isEqual(obj, this.value));
      } else {
        const index = newModel.indexOf(this.value);

        if (index !== -1) {
          newModel.splice(index, 1);
        }
      }

      this.$emit("change", newModel);
    },
    addValueToModel(newModel) {
      newModel.push(this.value);

      this.$emit("change", newModel);
    },
    isEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    methods: {
      onClick() {
        this.$emit("update:modelValue", !this.inputValue ? 1 : 0);
      },
    },
  },
};
</script>
